<div class="page-wrapper">
  <div class="row no-gutter">
    <div class="col-sm-12">
      
      <amazon-header></amazon-header>
    </div>
    <div class="clearfix"></div>
    <div class="col-sm-2 side">
      <amazon-sidebar></amazon-sidebar>
    </div>
    <div class="col-sm-10">
      <div class="layout-wrap">
        <router-outlet></router-outlet>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
    <div>
      <amazon-footer></amazon-footer>
    </div>
  </div>
</div>

